import { Store } from "vuex";
import { state } from "@/store/medals";

/**
 * Looks up item id based on the provided `name` and `medals` array
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_id(name, medals) {
    var formattedName = clean(name);

    for (var i = 0; i < medals.length; i++){
        var listName = clean(medals[i].name);
        if (listName.includes(formattedName) || formattedName.includes(listName)){
            return medals[i].id;
        }
    }
}

function clean(str){
    var regExp = /[^0-9A-zÀ-ú]+/g;
    return str.toLowerCase().replace(regExp, '');

}

/**
 * Provide a list of medal sets from the provided `item`
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_sets(item) {
    var list = [];

    if(item !== null) {
        if (typeof item["medal_set"] === "object"){
            list = list.concat(item["medal_set"]);
        }

        if (typeof item["memorial_plaque"] === "object"){
            list = list.concat(item["memorial_plaque"]);
        }

        if (typeof item["memorial_cross"] === "object"){
            list = list.concat(item["memorial_cross"]);
        }
    }

    return list;
}

/**
 * Provide a list of medal names from the provided `item`
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_set_names(item) {
    var displayName = item["ObjDisplayName"];

    if (medal_is_set(item)){
        return item["DesObjCompNames"]
    }

    return [displayName];
}

/**
 * Provide a url of a medal set's image from the provided `item`
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_set_image(item) {

    if (item.media.length > 0
        && item.media[0].sizes
        && item.media[0].sizes.small
        && item.media[0].sizes.small.url) {
        return item.media[0].sizes.small.url;
    }
    return '';
}

/**
 * Provide an object of a medal set's image from the provided `item`
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_set_thumb(item) {

    if (item.media.length > 0
        && item.media[0].sizes
        && item.media[0].sizes.small
        && item.media[0].sizes.small.url) {
        return {
            src: item.media[0].sizes.small.url,
            title: item.MulTitle ? item.MulTitle : ''
        }
    }
    return {
        src: 'images/asset-placeholder.jpg',
        title: ''
    };
}

/**
 * Provide a list of of a medal set's images from the provided `item`
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_set_images(item) {
    if(item !== null) {
        if (item.media && item.media.length > 0) {
            let images = item.media.map(function (img) {
                let url = '';
                if (img.sizes && img.sizes.large && img.sizes.large.url) url = img.sizes.large.url;

                let caption = '';
                if (img.MulTitle) caption = img.MulTitle;

                return {
                    src: url,
                    title: caption
                };
            });

            return images;
        }
    }

    return [];
}

/**
 * Determines if `item` is a medal set
 * @param {*} item Dictionary based on `MedalModel` object
 */
export function medal_is_set(item) {
    var displayName = item["ObjDisplayName"];
    var cleanName = clean(displayName);

    if (cleanName.includes("medalset") || cleanName.includes("ensembledemédailles")){
        return true;
    }

    return false;
}
